import QRCode from "qrcode";

export interface ZatcaFields {
  sellerName: string;
  vatNumber: string;
  /** ختم زمني بصيغة ISO 8601 */
  timestamp: string;
  totalWithVat: number;
  vatTotal: number;
}

function toUtf8Bytes(value: string): number[] {
  return Array.from(new TextEncoder().encode(value));
}

/** يحوّل الحقل إلى صيغة TLV: [الوسم][الطول][القيمة] */
function toTlv(tag: number, value: string): number[] {
  const bytes = toUtf8Bytes(value);
  return [tag, bytes.length, ...bytes];
}

/**
 * يبني بيانات فاتورة ZATCA بصيغة TLV ثم يشفّرها Base64.
 * الوسوم: 1 اسم البائع، 2 الرقم الضريبي، 3 الختم الزمني، 4 الإجمالي شامل الضريبة، 5 إجمالي الضريبة.
 */
export function buildZatcaTlvBase64(fields: ZatcaFields): string {
  const bytes = [
    ...toTlv(1, fields.sellerName),
    ...toTlv(2, fields.vatNumber),
    ...toTlv(3, fields.timestamp),
    ...toTlv(4, fields.totalWithVat.toFixed(2)),
    ...toTlv(5, fields.vatTotal.toFixed(2)),
  ];
  let binary = "";
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary);
}

/** يولّد صورة QR (Data URL) من نص TLV المشفّر. */
export async function generateQrDataUrl(text: string): Promise<string> {
  try {
    return await QRCode.toDataURL(text, {
      margin: 1,
      width: 240,
      errorCorrectionLevel: "M",
      color: { dark: "#111111", light: "#FFFFFF" },
    });
  } catch {
    return "";
  }
}

/** يبني ختماً زمنياً ISO من تاريخ اليوم + وقت الطلب (HH:MM) */
export function buildOrderTimestamp(time: string): string {
  const now = new Date();
  const date = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(
    now.getDate(),
  ).padStart(2, "0")}`;
  return `${date}T${time}:00`;
}